<div class="d-flex flex-column" *ngFor="let person of sortedAndFilteredParticipants; let  i = index">
    <hr class="light-divider p-0 m-0" *ngIf="i != 0" />
    <div>
        <p class="py-1 d-flex justify-content-between">
            <span>{{ person.firstName }} {{ person.lastName }}</span>
            <span *ngIf="person.phone !== null"> {{ person.phone }}</span>
        </p>
    </div>
    <div style="max-width: 100%;" class="d-flex gap-1 flex-wrap mb-2" *ngIf="person.registrationDetails.length">
        <div class="badge badge-default d-flex gap-1 p-1 registration-detail-custom-badge text-truncat"
            *ngFor="let registrationDetail of person.registrationDetails" role="button"
            [tooltip]="registrationDetail.questionTitle" triggers="hover" #t="bs-tooltip"
            (click)="openRegistrationDetailsModal(person,[registrationDetail]); t.hide()">
            <span><i class="fa-xs" [className]="registrationDetail.iconCode ?? 'fa-solid fa-circle-info'"></i></span>
            <span class="text-truncate">{{registrationDetail.answer}}</span>
        </div>

        <div class="badge badge-default d-flex gap-1 p-1" role="button"
            (click)="openRegistrationDetailsModal(person,person.registrationDetails)"
            *ngIf="person.registrationDetails.length >= 2">
            <span><i class="fa-solid fa-magnifying-glass"></i></span>
            <span>{{'assignments.participants.registrationDetails.showAll' | transloco}}</span>
        </div>
    </div>
</div>

<ng-container *ngIf="hasMoreThenMaxParticipants">
    <div class="d-flex justify-content-center">
        <button class="btn btn-sm btn-default" *ngIf="isParticipantsCountRestricted"
            (click)="isParticipantsCountRestricted = false">
            {{'assignments.participants.showMore' | transloco}}
            <i class="fa-solid fa-chevron-down"></i>
        </button>
        <button class="btn btn-sm btn-default" *ngIf="!isParticipantsCountRestricted"
            (click)="isParticipantsCountRestricted = true">
            {{'assignments.participants.showLess' | transloco}}
            <i class="fa-solid fa-chevron-up"></i>
        </button>
    </div>
</ng-container>